<template>
  <div class="neighbourhood bg-white FoundersGrotesk">
    <section class="container-xl">
      <div class="mb-4 h-100">
        <b-row>
          <b-col class="m-0 p-0 hood-col" cols="12" md="12">
            <div class="lg-text text-uppercase">THE NEIGHBOURHOOD</div>
            <div class="md-text pb-4">
              We acknowledge that Ode is located on the Indigenous land of the
              Wendat, the Anishinabek, Haudenosaunee & the Mississaugas of the
              New Credit First Nation. We express our gratitude towards all
              Indigenous Peoples who continue to live on this land and who have
              given us the privilege of calling these lands our home.
            </div>
          </b-col>
        </b-row>
      </div>

      <div class="w-100 d-flex align-items-center justify-content-center">
        <div class="outer-container">
          <div v-for="(category, index) in categories" :key="index">
            <b-row>
              <b-col cols="12" class="mb-5 p-0 m-0">
                <div class="slick-wrapper">
                  <div class="md-header-text text-uppercase pb-3">
                    {{ category.name }}
                  </div>
                  <VueSlickCarousel v-bind="settings">
                    <div
                      v-for="(image, imgIndex) in category.images"
                      :key="imgIndex"
                      class="slick-container p-0 m-0"
                    >
                      <div class="slider-gap">
                        <div class="md-text pl-3 pb-1 pt-3">
                          {{ image.title }}
                        </div>
                        <div class="sm-header-text text-uppercase pl-3 pb-3">
                          {{ image.address }}
                        </div>
                        <img
                          :src="image.img"
                          alt="Carousel Image"
                          class="d-block img-fluid pb-3 w-100 shop-img"
                        />
                        <div class="sm-text px-3 pb-3">{{ image.text }}</div>
                      </div>
                    </div>
                  </VueSlickCarousel>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  data() {
    return {
      settings: {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: true,
              dots: true,
              initialSlide: 0,
            },
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0,
            },
          },
        ],
      },
      categories: [
        {
          name: "Dine",
          images: [
            {
              img: "/img/neighbourhood/Milou.jpg",
              title: "Milou",
              address: "1375 Dundas St W",
              addressLink: "",
              text: "Everyone who eats at Milou is gorgey, it’s a fact. On top of attractive patrons, its got the chicest parisian cafe decor and an impeccable menu to match. Come here for sandos you’ll have dreams about, a gorgeous steak frites, or the stand out basque cheesecake.",
            },
            {
              img: "/img/neighbourhood/Manita.jpg",
              title: "Manita",
              address: "210 Ossington Ave",
              addressLink: "",
              text: "This place is like that one friend you have who is just good at everything. But they are also super earnest, so you don't resent them. We love it for breakfast and lunch, but the dinner also slaps. Amazing food, staff, music and vibes.",
            },
            {
              img: "/img/neighbourhood/Hanmoto.jpg",
              title: "Hanmoto",
              address: "2 Lakeview Ave",
              addressLink: "",
              text: "I once went here with my brother and he ate an entire chunk of wasabi thinking it was an avocado, and the memory of that makes me smile everytime. Back to the restaurant though, this place is a must visit if flavourful, deeply satisfying Japanese-American snacks are your thing.",
            },
            {
              title: "The Federal",
              address: "1438 DUNDAS ST W",
              addressLink: "",
              img: "/img/neighbourhood/Federal.jpg",
              text: "The neighborhood breakfast spot. Get the Gold Standard breakfast sando, with beyond meat (even if you like meat, this has a nice kick to it!) Beat the rush and show up early to avoid the long wait :)",
            },
            {
              img: "/img/neighbourhood/Foxley.jpg",
              title: "Foxley",
              address: "207 OSSINGTON AVE",
              addressLink: "",
              text: "We love this place so much we are actually thinking of naming our first born after it. Self described as “Asian & Pan-Latin”, whatever that means, we’re (registered trademark of MacDonald’s) lovin’ it! Order the arctic char ceviche, trust us.",
            },
            {
              img: "/img/neighbourhood/DeathInVeniceGelato.jpg",
              title: "Death in Venice Gelato",
              address: "1418 Dundas St W",
              addressLink: "",
              text: "Not your mama’s gelato place. Creative flavours that push the boundaries of what can even be considered gelato. They even have an award winning “Cheeseboard” flavour, what a time to be alive!",
            },
            {
              img: "/img/neighbourhood/Honeys.jpg",
              title: "Honey’s",
              address: "1448 Dundas St W",
              addressLink: "",
              text: "I can’t believe it’s not dairy! With the classics and some iconic seasonal flavours (they have corn ice cream right now!) this place has some of the best scoops in the city. Honey’s, myself and my severe lactose intolerance, thank you.",
            },
          ],
        },
        {
          name: "Drink",
          images: [
            {
              img: "/img/neighbourhood/Midfield.jpg",
              title: "Midfield Wine Bar",
              address: "1434 Dundas St W",
              addressLink: "",
              text: "This wine bar has everything from that bottle you get when you want to impress your date but don’t want to take out a second mortgage to an easy peasy pinot grisy. And not your typical “stuffy” wine bar – cozy, laid back vibe, and lest we forget they have delicious food too.",
            },
            {
              img: "/img/neighbourhood/Loveless.jpg",
              title: "Loveless",
              address: "1430 Dundas St W",
              addressLink: "",
              text: "So you want to be a local? This is the neighbourhood watering hole, come here for a beer, cocktail or coffee on the patio and post up for some primo people watching.",
            },
            {
              img: "/img/neighbourhood/Mordecai.jpg",
              title: "Bar Mordecai",
              address: "1272 Dundas St W ",
              addressLink: "",
              text: "Wes Anderson inspired decor? Check! Inventive cocktails? Check! Karaoke rooms? Check! The kind of place you start at for a drink at a reasonable hour and end up staying until 2am. We lived it and we loved it.",
            },
            {
              img: "/img/neighbourhood/Cocktail-bar.jpg",
              title: "Cocktail Bar",
              address: "923 Dundas St W",
              addressLink: "",
              text: "The kind of place where the bartender hand carves your ice cube out of a much larger ice cube made from triple distilled glacier water. A dimly lit, classy joint to enjoy a few craft wobbly pops. Oh and the patio is tres cute.",
            },
            {
              img: "/img/neighbourhood/Piscina.jpg",
              title: "La Piscina",
              address: "1615 Dundas St W",
              addressLink: "",
              text: "You know that friend of yours who keeps bees, throws pottery, has a full time job, and somehow manages to be really good at all of it? This is the physical manifestation of that person. Cafe/grocer by day, cocktail lounge/tapas by night. Get involved!",
            },
            {
              img: "/img/neighbourhood/Milkys.jpg",
              title: "Milky’s",
              address: "760 Dundas St W",
              addressLink: "",
              text: "You know that friend of yours who keeps bees, throws pottery, has a full time job, and somehow manages to be really good at all of it? This is the physical manifestation of that person. Cafe/grocer by day, cocktail lounge/tapas by night. Get involved!",
            },
            {
              img: "/img/neighbourhood/Larrys.png",
              title: "Larry's Back Pocket",
              address: "1413 Dundas St W",
              addressLink: "",
              text: "Our cute little neighbour with the most delectable coffee beverages and baked goods (butter tarts! Our fave). This should be your first stop in the morning.",
            },
            {
              img: "/img/neighbourhood/CryBabyGallery.png",
              title: "Cry Baby Gallery",
              address: "1468 Dundas St W",
              addressLink: "",
              text: 'Have you ever thought to yourself "Should I go see some art that will make me re-evaluate what it means to be human orrr should I just go get some wobbly pops and talk shit with my friends?" Well at Cry Baby Gallery you can do both! Gallery up front, speakeasy style bar in the back with some of the most inventive cocktails this city has to offer.',
            },
          ],
        },
        {
          name: "Shop",
          images: [
            {
              img: "/img/neighbourhood/VSP.jpg",
              title: "VSP Consignment",
              address: "1410 Dundas St W",
              addressLink: "",
              text: "Go here even if you don’t need a new outfit. Impeccably curated collection of designer and vintage pieces for your shopping pleasure.",
            },
            {
              img: "/img/neighbourhood/ETG.jpg",
              title: "Easy Tiger Goods",
              address: "1447 Dundas St W",
              addressLink: "",
              text: "A lifestyle shop full of beautiful, unusual, exciting things. The perfect place to find a gift for someone if that someone is cool, if they are not cool, this gift will make them cool.",
            },
            {
              img: "/img/neighbourhood/SoopSoop.jpg",
              title: "Soop Soop",
              address: "1319 Dundas St W",
              addressLink: "",
              text: "We love so many things about this place, one of them being that it feels like an office from the 1990s. I’m gonna need you to go ahead and visit this shop, especially if you are into art-house publications and hype beast streetwear.",
            },
            {
              img: "/img/neighbourhood/Shopcoat.png",
              title: "Shopcoat",
              address: "1167 Dundas St W",
              addressLink: "",
              text: "Do you need a shirt with artfully placed holes in it? Or a long denim coat? No? Well go here anyway, hands down one of the best vintage shops in the city and must visit for all of your sartorial needs. ",
            },
          ],
        },
        {
          name: "Play",
          images: [
            {
              img: "/img/neighbourhood/TIFF.jpg",
              title: "TIFF Lightbox",
              address: "2A  Kensington Ave",
              addressLink: "",
              text: "If there is one thing Torontonians like, its a patio. Put anything on a patio and we are into it. El Rey combines patio with tequilla and ceviche – all things that are good. The hottest ticket in the city in the summertime.",
            },
            {
              img: "/img/neighbourhood/Trinity.jpg",
              title: "Trinity Bellwoods",
              address: "790 Queen St W",
              addressLink: "",
              text: "Bellwoods, a blanket and your boo, and you’ve got yourself a pretty nice little afternoon lined up. The best park in the city for watching people fall off of slacklines, participating in a drumming circle, or just rubbing fruit linaments and noxema over your loved one’s body.",
            },
            {
              img: "/img/neighbourhood/Kensington-Market.jpg",
              title: "Kensington Market",
              address: "It’s a neighbourhood",
              addressLink: "",
              text: "What to do: a shrimp taco from Seven Lives, a Churro from Pancho’s, jerk chicken pasta from Rasta Pasta, and a slice of pie at Wanda’s Pie in the Sky, if at this point you are a) still hungry and b) don’t have diabetes, head to Dumpling House on Spadina for some yumma dumps. Gotta be a better way of saying that.",
            },
            {
              img: "/img/neighbourhood/SugarBeach.jpg",
              title: "Sugar Beach",
              address: "25 Dockside Drive",
              addressLink: "",
              text: "Some people say it is not a real beach; and of course, it is not. But the sand is still white and the umbrellas are still pink, a nice little corner to while away an afternoon and get your tan on.",
            },
            {
              img: "/img/neighbourhood/Hanlans.jpg",
              title: "Hanlan's Point",
              address: "The Toronto Islands",
              addressLink: "",
              text: "No need to pack your picnic basket when you head to Hanlan’s Point because there are plenty of snacks on this clothing optional beach! K that sounded less creepy in my mind. Anyway, beach, BBQ and buns - doesn’t get better than that! ",
            },
          ],
        },
      ],
    };
  },
  components: { VueSlickCarousel },
  mounted() {
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.refresh();
    setTimeout(() => {}, 500);
  },
  methods: {
    formatText(text) {
      return text.replace(/\n/g, "<br>");
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/styles/variables";
.neighbourhood {
  padding: 50px 50px 50px 50px;
  @media screen and (max-width: 1176px) {
    padding: 40px 60px 100px 60px;
  }
  @media screen and (max-width: 450px) {
    padding: 40px 40px 100px 40px;
  }
  .link-text {
    letter-spacing: 1px;
  }
  a:link,
  a:visited,
  a:hover,
  a:active {
    color: $m-black;
    text-decoration: none;
  }

  .outer-container {
    width: 100%;
    @media screen and (max-width: 700px) {
      width: 70%;
    }
    @media screen and (max-width: 500px) {
      width: 100%;
    }
  }
  .slick-container {
    border: 10px solid $m-white;
    box-sizing: border-box;
  }

  .slick-container img {
    width: 280px;
    height: 260px;
    @media screen and (max-width: 600px) {
      height: 200px;
    }
  }

  .slider-gap {
    border: 2px solid $m-black;
    height: 480px;
    @media screen and (max-width: 500px) {
      height: 440px;
    }
  }
}
</style>

<style lang="scss">
@import "~@/assets/styles/variables";
.neighbourhood {
  .outer-container {
    .slick-prev.slick-arrow {
      width: 50px;
      height: 50px;
    }
    .slick-prev:before {
      content: "";
      display: inline-block;
      width: 55px;
      height: 55px;
      background-image: url("/img/back.svg");
      background-position: center;
      background-repeat: no-repeat;
      @media screen and (max-width: 1157px) {
        width: 45px;
        height: 45px;
      }
      @media screen and (max-width: 600px) {
        width: 40px;
        height: 40px;
      }
      @media screen and (max-width: 450px) {
        display: none;
      }
    }
    .slick-prev {
      position: absolute;
      left: -70px;
      @media screen and (max-width: 1157px) {
        left: -50px;
      }
      @media screen and (max-width: 600px) {
        left: -50px;
      }
    }
    .slick-next {
      position: absolute;
      right: -35px;
      @media screen and (max-width: 1157px) {
        right: -25px;
      }
      @media screen and (max-width: 600px) {
        right: -25px;
      }
    }
    .slick-next:before {
      content: "";
      display: inline-block;
      width: 55px;
      height: 55px;
      background-image: url("/img/forward.svg");
      background-position: center;
      background-repeat: no-repeat;
      @media screen and (max-width: 1157px) {
        width: 40px;
        height: 40px;
      }
      @media screen and (max-width: 600px) {
        width: 40px;
        height: 40px;
      }
      @media screen and (max-width: 450px) {
        display: none;
      }
    }
  }
}
</style>
